import { createTheme } from '@mantine/core';

// Two overrides, deliberately. Divergence from the mobile brand is a feature — an
// admin screenshot should never be mistakable for the product. No Unistyles, no
// Lora, no import from the mobile theme tokens.
export const theme = createTheme({
  primaryColor: 'indigo',
  defaultRadius: 'sm',
});
